import { UserAction, UserState, UserActionTypes } from "./types";

const initialState: UserState = {
  email: "",
  name: "",
  phone_number: "",
  userName: "",
  selectedOrg: {
    id: "",
    name: "",
    logo: "",
    associated_dealers: [],
    can_file_claim: false,
    permissions: [],
    chatbot_enabled: false,
    can_cancel_plan: true,
  },
  contracts: {
    data: [],
    info: {
      per_page: 1,
      count: 1,
      sort_by: "id",
      page: 1,
      sort_order: "desc",
      more_records: true,
    },
  },
  pendingContracts: {
    data: [],
    info: {
      page: 1,
      per_page: 1,
      total_records: 1,
      total_pages: 1,
    },
  },
  claims: {
    data: [],
    info: {
      per_page: 1,
      count: 1,
      sort_by: "id",
      page: 1,
      sort_order: "desc",
      more_records: true,
    },
  },
  skus: [],
};

export const userReducer = (
  state: UserState = initialState,
  action: UserActionTypes
): UserState => {
  switch (action.type) {
    case UserAction.SET_USER_DATA: {
      return {
        ...state,
        ...action?.payload,
      };
    }

    case UserAction.CLEAN_UP: {
      return {
        ...initialState,
      };
    }

    case UserAction.SET_CONTRACT_RECORDS: {
      return {
        ...state,
        contracts: {
          data: action.payload.data || [],
          info: action.payload.info || {},
        },
      };
    }

    case UserAction.SET_SKUsOPTIONS: {
      return {
        ...state,
        skus: action.payload || [],
      };
    }

    case UserAction.SET_PENDING_CONTRACT_RECORDS: {
      return {
        ...state,
        pendingContracts: {
          data: action.payload.data || [],
          info: action.payload.info || {},
        },
      };
    }

    case UserAction.SET_CLAIMS: {
      return {
        ...state,
        claims: {
          data: action.payload.data || [],
          info: action.payload.info || {},
        },
      };
    }

    default:
      return state;
  }
};
